// extracted by mini-css-extract-plugin
export default {"orb":"VoiceOrb_orb__b8amg"};